import {
  toPublicPath,
  useHead,
  useRequestURL,
  useRoute,
  useSeoMeta,
} from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from '~/scopes/campaign/composables/useCampaignSeo.translations'
import backMarket from '~/scopes/campaign/const/back-market.translations'

const OG_IMAGE = {
  src: '/mine-my-phone/og_image.jpg',
  width: 1200,
  height: 630,
}

export function useCampaignSeo() {
  const i18n = useI18n()
  const route = useRoute()
  const { origin } = useRequestURL()

  const locale = computed(() => {
    const param = route.params.locale

    return Array.isArray(param) ? param[0] : param
  })

  const canonical = computed(() => `${origin}${route.path}`)

  const title = computed(() => i18n(translations.title))
  const description = computed(() => i18n(translations.description))
  const imageAlt = computed(() => i18n(translations.imageAlt))
  const siteName = computed(() => i18n(backMarket.label))
  const image = toPublicPath(OG_IMAGE.src)

  useSeoMeta({
    title,
    description,
    ogTitle: title,
    ogDescription: description,
    ogUrl: canonical,
    ogType: 'website',
    ogSiteName: siteName,
    ogImage: image,
    ogImageWidth: OG_IMAGE.width,
    ogImageHeight: OG_IMAGE.height,
    ogImageAlt: imageAlt,
    twitterCard: 'summary_large_image',
    twitterTitle: title,
    twitterDescription: description,
    twitterImage: image,
    twitterImageAlt: imageAlt,
  })

  useHead({
    htmlAttrs: { lang: locale },
    link: [{ rel: 'canonical', href: canonical }],
  })
}
